export interface FaqItem {
    q: string;
    a: string;
}

// Answer copy is forthcoming from the client — placeholders for now.
export const MEMBERSHIP_FAQ: FaqItem[] = [
    {
        q: 'When will I be billed for my membership?',
        a: 'You are billed at sign-up and then on the same date each billing period. (Details coming soon.)',
    },
    {
        q: 'What happens after I sign up for my membership?',
        a: 'Your member benefits and discounts activate immediately. (Details coming soon.)',
    },
    {
        q: 'If I’m not satisfied with my membership, what is the cancellation policy? Will I be refunded?',
        a: 'You can cancel anytime from your account. (Full policy coming soon.)',
    },
];
